import React from 'react'
import { Flex } from '@fundamentals'
import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material'
import { Palette } from '@core/theme/color-palette-siteassist'

const CHIP_STYLES = {
  up: {
    bgcolor: Palette.Green[50],
    color: Palette.Green[800],
    Icon: TrendingUp,
  },
  down: {
    bgcolor: Palette.Red[50],
    color: Palette.Red[900],
    Icon: TrendingDown,
  },
  flat: {
    bgcolor: Palette.Grey[100],
    color: Palette.Grey[700],
    Icon: TrendingFlat,
  },
}

const chipDirection = (percent: number): keyof typeof CHIP_STYLES => {
  if (percent === 0) {
    return 'flat'
  }
  return percent > 0 ? 'up' : 'down'
}

export const PercentageChangeChip: React.FC<{
  change?: number | null
}> = ({ change }) => {
  if (change === null || change === undefined) {
    return null
  }
  const percent = Math.round(change * 100)
  const { bgcolor, color, Icon } = CHIP_STYLES[chipDirection(percent)]

  return (
    <Flex
      alignItems='center'
      gap={0.5}
      sx={{
        bgcolor,
        color,
        borderRadius: 999,
        px: 1.25,
        py: 0.25,
        fontSize: 12,
        lineHeight: 1.6,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon sx={{ fontSize: 14 }} />
      {percent > 0 ? `+${percent}%` : `${percent}%`}
    </Flex>
  )
}
